import React from "react";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { PRESETS, presetRange } from "./iaUtils";

const SEL = "h-9 px-2.5 border border-[#E5E2D9] rounded-md bg-white text-xs";
const SR_STATUSES = ["NEW", "QUOTED", "APPROVED", "SCHEDULED", "IN_PROGRESS", "COMPLETED"];

function Select({ value, onChange, testid, children }) {
  return <select value={value || ""} onChange={e => onChange(e.target.value)} data-testid={testid} className={SEL}>{children}</select>;
}

export function FiltersBar({ f, setF, group, setGroup, categories }) {
  const set = (k) => (v) => setF(p => ({ ...p, [k]: v }));
  const pickPreset = (k) => {
    if (k === "custom") { setF(p => ({ ...p, preset: "custom" })); return; }
    const [from, to] = presetRange(k);
    setF(p => ({ ...p, preset: k, from, to }));
  };
  return (
    <div className="sticky top-0 z-20 -mx-1 px-1 py-3 bg-[#FAF9F6]/95 backdrop-blur-md border-b border-[#E5E2D9] space-y-2" data-testid="ia-filters">
      <div className="flex flex-wrap items-center gap-1.5">
        {PRESETS.map(([k, l]) => (
          <button key={k} onClick={() => pickPreset(k)} data-testid={`ia-preset-${k}`}
                  className={`h-8 px-3 rounded-full text-xs font-medium transition-colors ${f.preset === k ? "bg-[#1A1A1A] text-white" : "bg-white border border-[#E5E2D9] text-[#5C5A55] hover:border-[#1A1A1A]"}`}>
            {l}
          </button>
        ))}
        <input type="date" value={f.from} onChange={e => setF(p => ({ ...p, preset: "custom", from: e.target.value }))}
               className={SEL} data-testid="ia-from"/>
        <span className="text-xs text-[#8A8780]">to</span>
        <input type="date" value={f.to} onChange={e => setF(p => ({ ...p, preset: "custom", to: e.target.value }))}
               className={SEL} data-testid="ia-to"/>
        <div className="ml-auto inline-flex rounded-md border border-[#E5E2D9] overflow-hidden" data-testid="ia-group">
          {[["day", "Daily"], ["week", "Weekly"], ["month", "Monthly"]].map(([k, l]) => (
            <button key={k} onClick={() => setGroup(k)} data-testid={`ia-group-${k}`}
                    className={`h-8 px-3 text-xs font-medium ${group === k ? "bg-[#2D5A27] text-white" : "bg-white text-[#5C5A55]"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        <Select value={f.source} onChange={set("source")} testid="ia-source">
          <option value="all">All sources</option><option value="sr">Service Requests</option>
          <option value="hsr">Health Service Requests</option><option value="booking">Health Bookings</option>
        </Select>
        <Select value={f.category} onChange={set("category")} testid="ia-category">
          <option value="">All categories</option>
          {(categories || []).map(c => <option key={c} value={c}>{c}</option>)}
        </Select>
        <Select value={f.sr_status} onChange={set("sr_status")} testid="ia-sr-status">
          <option value="">All SR statuses</option>{SR_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
        </Select>
        <Select value={f.pay_state} onChange={set("pay_state")} testid="ia-pay-state">
          <option value="">All payment states</option>
          {["prepaid", "paid", "unpaid", "refunded"].map(s => <option key={s} value={s}>{s[0].toUpperCase() + s.slice(1)}</option>)}
        </Select>
        <Select value={f.pay_source} onChange={set("pay_source")} testid="ia-pay-source">
          <option value="">All payment sources</option>
          {[["wallet", "Wallet"], ["razorpay", "Razorpay"], ["upi", "UPI"], ["cash", "Cash"], ["manual", "Manual"]].map(([k, l]) =>
            <option key={k} value={k}>{l}</option>)}
        </Select>
        <div className="relative">
          <MagnifyingGlass size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[#8A8780]"/>
          <input defaultValue={f.q} onKeyDown={e => e.key === "Enter" && set("q")(e.target.value.trim())}
                 onBlur={e => set("q")(e.target.value.trim())} placeholder="Customer name / phone / code"
                 data-testid="ia-search" className={`${SEL} pl-7 w-56`}/>
        </div>
      </div>
    </div>
  );
}
